// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Fwm0","content":"styles_content__Ai68k","tableWrap":"styles_tableWrap__PmFwd"};